import { EMPTY_STRING } from '../constants/common';
import { generateUniqueId } from '../helper/common';
import { IPurchaseOrderItem } from '../interface/purchaseOrder';

export const dataDefaultItemProductPurchaseOrder: IPurchaseOrderItem = {
  id: generateUniqueId(),
  inventoryId: EMPTY_STRING,
  variantId: EMPTY_STRING,
  unitPrice: EMPTY_STRING,
  quantity: EMPTY_STRING,
  total: EMPTY_STRING,
  idRemove: EMPTY_STRING,
};
